import { call, put, takeEvery } from 'redux-saga/effects';
import { sagaTypes } from './types';
import { IDataPage } from '../../interfaces/common';
import { IAction } from '../utils';
import { getCollections, getCollectionProducts } from '../../api/collections';
import { getAllCollectionsAction, getCollectionAction } from './action';
import { ICollections, ICollectionProducts } from '../../interfaces/collections';

export function* getAllCollectionsWorkerSaga({ payload }: IAction<string>) {
  const res: IDataPage<ICollections[]> = yield call(getCollections, payload as string);
  yield put(getAllCollectionsAction(res?.data?.items || []));
}

export function* getCollectionWorkerSaga({ payload }: IAction<string>) {
  const res: IDataPage<ICollectionProducts[]> = yield call(getCollectionProducts, payload as string);
  yield put(getCollectionAction(res?.data?.items || []));
}

export function* collectionsWatcherSaga() {
  yield takeEvery(sagaTypes?.GET_ALL_COLLECTIONS, getAllCollectionsWorkerSaga);
  yield takeEvery(sagaTypes?.GET_COLLECTION, getCollectionWorkerSaga);
}
